import { Input, DropdownButton } from "@biteship/atom";

export default function ExpressRatesForm(props) {
  const onSelectType = (type) => {
    if (type.value !== props.inputType.value)
      props.setInputData({
        ...props.inputData,
        origin: "",
        destination: "",
      });
    props.setInputType({
      title: type.title,
      value: type.value,
    });
  };

  const inputTypeActions = () => {
    const inputTypes = [
      { title: "Kodepos", value: "kodepos" },
      { title: "Kecamatan", value: "kecamatan" },
      { title: "Kota", value: "kota" },
    ];

    return inputTypes.map((inputType) => ({
      title: inputType.title,
      onClick: () => onSelectType(inputType),
    }));
  };

  const onChange = (key, value) => {
    if (key === "origin" || key === "destination") value = value.toUpperCase();
    props.setInputData({
      ...props.inputData,
      [key]: value,
    });
  };

  return (
    <div className="p-2">
      {props.useType === "create" && (
        <DropdownButton
          title={props.inputType.title}
          actions={[inputTypeActions()]}
          className="w-full mt-4 mb-4"
          buttonClassName="border-gray-700"
          inheritWidth
        />
      )}
      {(props.inputType.value || props.useType === "edit") && (
        <div>
          {props.useType === "create" && (
            <div className="flex justify-between space-x-2 mb-4">
              <Input
                label={`${props.inputType.title} Asal`}
                placeholder={`Masukkan ${props.inputType.value !== "kodepos" ? "ID " : ""}${
                  props.inputType.value
                }`}
                className="w-full"
                value={props.inputData.origin}
                onChange={(e) => onChange("origin", e.target.value)}
              />
              <Input
                label={`${props.inputType.title} Tujuan`}
                placeholder={`Masukkan ${props.inputType.value !== "kodepos" ? "ID " : ""}${
                  props.inputType.value
                }`}
                className="w-full"
                value={props.inputData.destination}
                onChange={(e) => onChange("destination", e.target.value)}
              />
            </div>
          )}
          <div className="flex justify-between space-x-2 mb-4 mt-2">
            <Input
              label={`Harga Dasar`}
              placeholder={`Harga (wajib)`}
              className="w-full"
              type="number"
              addOns="leading"
              value={props.inputData.basePrice}
              onChange={(e) => onChange("basePrice", e.target.value)}
            />
            <Input
              label={`Harga Tambahan / kg`}
              placeholder={`Harga (optional)`}
              className="w-full"
              type="number"
              addOns="leading"
              value={props.inputData.weightExtraPrice}
              onChange={(e) => onChange("weightExtraPrice", e.target.value)}
            />
            <Input
              label={`Harga Tambahan / cm 3`}
              placeholder={`Harga (optional)`}
              className="w-full"
              type="number"
              addOns="leading"
              value={props.inputData.volumeExtraPrice}
              onChange={(e) => onChange("volumeExtraPrice", e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
